/*------------------------------------*\
	#FILE UPLOAD
\*------------------------------------*/

"use strict";

const panel = '.js-tab-panel',
	fileUpload = '.js-file-upload',
	fileUploadInput = '.js-file-upload-input',
	fileUploadList = '.js-file-upload-list',
	fileUploadLegend = '.js-upload-area-legend',
	fileUploadRemoveButton = '.js-file-upload-remove-button',
	isHidden = 'is-hidden',
	filesUploadDataTransferBuilding = new DataTransfer(),
	filesUploadDataTransferRoof = new DataTransfer(),
	filesUploadDataTransferPlans = new DataTransfer(),
	filesUploadDataTransferOther = new DataTransfer()
;

document.addEventListener("DOMContentLoaded", () => {
	document.querySelectorAll('.js-file-upload .js-file-upload-input').forEach(input => {
		updateFileInput(input);
		input.addEventListener('change', () => {
			const dt = getDataTransferForInput(input);
			for (let i = 0; i < input.files.length; i++) {
				if(input.accept.split(',').includes(input.files[i].type)) {
					dt.items.add(input.files[i]);
				}
			}
			input.files = dt.files;
			updateFileInput(input);
		}, {passive: true});
	})
	document.querySelectorAll('form').forEach(form => {
		form.addEventListener('validationFailedToManyFiles', validationFailedToManyFiles, {passive: true});
		form.addEventListener('validationFailedFileSize', validationFailedFileSize, {passive: true});
		form.addEventListener('validationSuccessFile', validationSuccessFile, {passive: true});
	});
}, {passive: true, once: true});

function getDataTransferForInput(input) {
	switch (input.dataset['uploadCategory']) {
		case 'building':
			return filesUploadDataTransferBuilding;
		case 'roof':
			return filesUploadDataTransferRoof;
		case 'plans':
			return filesUploadDataTransferPlans;
		case 'other':
			return filesUploadDataTransferOther;
		default:
			return filesUploadDataTransferOther;
	}
}

function updateFileInput(target) {
	const tabName = target.closest(panel).getAttribute('aria-labelledby'),
		counter = document.querySelector('#' + tabName + ' .js-tab-counter'),
		list = target.parentElement.querySelector(fileUploadList),
		legend = target.parentElement.querySelector(fileUploadLegend);

	updateFileCounter(target, counter, legend);
	updateFilePreview(target, list);
	validateFileForms(target);
}

function updateFileCounter(target, destination, legend) {
	const count = getDataTransferForInput(target).items.length,
		countPreset = target.parentElement.querySelectorAll('input[type=hidden][value^="file:"]').length,
		totalCount = count + countPreset;

	if (totalCount > 0) {
		destination.innerText = totalCount;
		destination.classList.remove(isHidden);
		if (totalCount === 1) {
			legend.innerText = totalCount + ' ' + legend.dataset.translationSingle;
		} else {
			legend.innerText = totalCount + ' ' + legend.dataset.translationMultiple;
		}
	} else {
		destination.innerText = '';
		destination.classList.add(isHidden);
		legend.innerText = legend.dataset.translationEmpty;
	}
}

function updateFilePreview(target, destination) {
	const values = getDataTransferForInput(target).items,
		presetValues = target.parentElement.querySelectorAll('.js-presets span');

	let list = '';

	presetValues.forEach(value => {
		list += `
			<li class="c-file-upload__item">
				<div class="c-file-upload__chip">
					<i class="c-file-upload__icon c-icon c-icon--system-file"></i>
					<label class="c-file-upload__label">${value.innerText}</label>
					<p class="c-file-upload__filesize">${getFileSize(value.dataset.fileSize)}</p>
				</div>
				<button class="c-file-upload__circle js-file-upload-remove-button" data-file-id="${value.dataset.fileId}" data-file-preset>
					<i class="c-file-upload__circle-icon c-icon c-icon--system-close"></i>
				</button>
			</li>`;
	})

	for (let i = 0; i < values.length; i++) {
		const value = values[i].getAsFile();
		list += `
			<li class="c-file-upload__item">
				<div class="c-file-upload__chip">
					<i class="c-file-upload__icon c-icon c-icon--system-file"></i>
					<label class="c-file-upload__label">${value.name}</label>
					<p class="c-file-upload__filesize">${getFileSize(value.size)}</p>
				</div>
				<button class="c-file-upload__circle js-file-upload-remove-button" data-file-id="${i}">
					<i class="c-file-upload__circle-icon c-icon c-icon--system-close"></i>
				</button>
			</li>`;
	}

	destination.innerHTML = list;
	destination.querySelectorAll(fileUploadRemoveButton).forEach(removeButton => {
		removeButton.addEventListener('click', e => {
			e.stopPropagation();
			e.preventDefault();

			removeFileFromInput(
				removeButton.dataset,
				removeButton.closest(fileUpload).querySelector(fileUploadInput)
			);
		}, {once: true});
	})
}

function removeFileFromInput(file, target) {
	if (file.filePreset !== undefined) {
		target.parentElement.querySelector('input[type=hidden][value^="file:' + file.fileId + '"]').remove();
		target.parentElement.querySelector('.js-presets [data-file-id="' + file.fileId + '"]').remove();
	} else {
		getDataTransferForInput(target).items.remove(file.fileId)
	}
	updateFileInput(target);
}

function getFileSize(bytes) {
	const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

	let pow = Math.floor(Math.log(bytes || 1) / Math.log(1024));
	pow = Math.min(pow, units.length - 1);
	bytes /= Math.pow(1024, pow);

	const formattedBytes = new Intl.NumberFormat(undefined, {maximumFractionDigits: 1}).format(bytes);

	return `${formattedBytes} ${units[pow]}`;
}

function getTotalFileAmount(form) {
	let files = 0;
	form.querySelectorAll('input[type=file]').forEach(input => {
		files += getDataTransferForInput(input).items.length;
	});
	files += form.querySelectorAll('input[type=hidden][value^="file:"]').length;

	return files;
}

function getTotalFileSize(form) {
	let size = 0;
	form.querySelectorAll('input[type=file]').forEach(input => {
		for (let i = 0; i < getDataTransferForInput(input).items.length; i++) {
			size += parseInt(getDataTransferForInput(input).items[i].getAsFile().size);
		}
	})
	form.querySelectorAll('.js-presets span').forEach(element => size += parseInt(element.dataset.fileSize));

	return size;
}

function errorAllInputFiles(form,amountError = false, sizeError = false) {
	let errorMessageTranslation = '';
	if(amountError) {
		errorMessageTranslation += document.querySelector('.js-file-upload').dataset.translationErrorMaxFiles
	}
	if(sizeError) {
		errorMessageTranslation += ' ' + document.querySelector('.js-file-upload').dataset.translationErrorFileSize
	}
	form.querySelectorAll('input[type=file]').forEach(input => {
		input.setCustomValidity(errorMessageTranslation)
	});
}

function removeErrorAllInputFiles(form) {
	form.querySelectorAll('input[type=file]').forEach(input => input.setCustomValidity(''));
}

function validateFileForms(target) {
	let error = false;
	let amountError = false;
	let sizeError = false;
	if (getTotalFileAmount(target.form) > 30) {
		error = true;
		amountError = true
		const validationFailedEvent = new Event('validationFailedToManyFiles');
		target.form.dispatchEvent(validationFailedEvent);
	}
	if (getTotalFileSize(target.form) > 100 * 1024 * 1024) { // 100MB
		error = true;
		sizeError = true
		const validationFailedSizeEvent = new Event('validationFailedFileSize');
		target.form.dispatchEvent(validationFailedSizeEvent);
	}
	if (error) {
		errorAllInputFiles(target.form, amountError, sizeError);
	} else {
		removeErrorAllInputFiles(target.form);
		const validationSuccessFile = new Event('validationSuccessFile');
		target.form.dispatchEvent(validationSuccessFile);
	}
}

function validationFailedToManyFiles(event) {
	const errorMessageTranslation = document.querySelector('.js-file-upload').dataset.translationErrorMaxFiles
	document.querySelectorAll('.js-file-upload').forEach(uploadArea => {
		const element = uploadArea.querySelector('.js-file-upload-hint');

		element.innerHTML = errorMessageTranslation;
		element.style.display = "block"
	});
}

function validationFailedFileSize(event) {
	const errorMessageTranslation = document.querySelector('.js-file-upload').dataset.translationErrorFileSize;
	document.querySelectorAll('.js-file-upload').forEach(uploadArea => {
		const element = uploadArea.querySelector('.js-file-upload-hint');

		element.innerHTML = errorMessageTranslation;
		element.style.display = "block"
	});
}

function validationSuccessFile(event) {
	document.querySelectorAll('.js-file-upload').forEach(uploadArea => {
		const element = uploadArea.querySelector('.js-file-upload-hint');
		element.innerHTML = '';
		element.style.display = "none"
	});
}
